// classificationColors.js
// Single source of truth for classification/control-marking colors.
//
// Colors follow the official US classification banner color codes:
// https://www.electrospaces.net/2013/09/the-us-classification-system.html
//   TOP SECRET (TS)                        - orange
//   SECRET (S)                              - red
//   CONFIDENTIAL (C)                        - blue
//   UNCLASSIFIED (U)                        - green
//   CUI (Controlled Unclassified Info)      - purple (not a level; kept for future use)
//   SCI (Sensitive Compartmented Info)      - yellow (compartment overlay, not a level; kept for future use)
//
// These are fixed, semi-standardized colors and are intentionally identical
// in both light and dark theme modes.
//
// This module is plain JS (no React/MUI imports) so it can be consumed both
// by the MUI theme (theme/index.js) and by non-React code (ProseMirror
// plugins, vanilla DOM helpers, plain CSS via generated custom properties).

export const CLASSIFICATION_COLORS = {
    U: {main: '#1B7A3D', bg: 'rgba(27, 122, 61, 0.12)'},     // Unclassified - green
    C: {main: '#1D5EBF', bg: 'rgba(29, 94, 191, 0.12)'},     // Confidential - blue
    S: {main: '#C62828', bg: 'rgba(198, 40, 40, 0.14)'},     // Secret - red
    TS: {main: '#C1560A', bg: 'rgba(230, 108, 15, 0.16)'},   // Top Secret - orange
    CUI: {main: '#7B3FA0', bg: 'rgba(123, 63, 160, 0.14)'},  // Controlled Unclassified Information - purple
    SCI: {main: '#8A6D1B', bg: 'rgba(212, 165, 23, 0.20)'},  // Sensitive Compartmented Information - yellow
};

/**
 * CSS custom property name for a given classification key and channel.
 * e.g. cssVarName('TS', 'main') -> '--classification-ts-main'
 */
export function cssVarName(key, channel) {
    return `--classification-${key.toLowerCase()}-${channel}`;
}

/**
 * Build a flat map of CSS custom properties (for injection into a `:root`
 * style block) from CLASSIFICATION_COLORS, e.g.
 *   { '--classification-u-main': '#1B7A3D', '--classification-u-bg': 'rgba(...)', ... }
 */
export function buildClassificationCssVars(colors = CLASSIFICATION_COLORS) {
    const vars = {};
    Object.keys(colors).forEach((key) => {
        vars[cssVarName(key, 'main')] = colors[key].main;
        vars[cssVarName(key, 'bg')] = colors[key].bg;
    });
    return vars;
}
